import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  addFieldData,
  setDateSurvey,
  setReturnedValue,
  showBtnNext
} from "../../actions";
import { connect } from "react-redux";
import { Button, FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import { translator } from "../../utils/i18n";
import { Trans } from "@lingui/macro";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { KeyboardDatePicker } from "@material-ui/pickers";

class Questionnaire extends Component {
  state = {
    value: "",
    resultSurvey: {},
    selectedDate: null,
    paramDateName: ""
  };

  componentDidMount() {
    this.props.step.data.fetchSource &&
      this.props.fetchData(this.props.step.data.fetchSource);
    this.props.showBtnNext(true);
  }

  componentWillUnmount() {
    const dataKey = this.props.step.data.keyValue;
    this.props.resetData(dataKey);
    this.props.showBtnNext(false);
  }

  getData = () => {
    const stepData = this.props.step.data;
    const dataKey = stepData.keyValue;
    if (this.props.dataSource && this.props.dataSource[dataKey]) {
      let data = this.props.dataSource[dataKey];
      if (data && stepData.formatSource) {
        data = stepData.formatSource(data);
      }
      return data;
    }
    return null;
  };

  handleChange = (e, id) => {
    const value = e.target.value;
    //const resultSurvey = [...this.state.resultSurvey];
    //resultSurvey[index] = value;
    const resultSurvey = { ...this.state.resultSurvey, [id]: value };
    this.setState({ resultSurvey });
  };

  handleChangeSelect = (e, id) => {
    const value = e.target.value;
    const resultSurvey = { ...this.state.resultSurvey, [id]: value };
    //resultSurvey[id] = value;
    this.setState({ resultSurvey });
  };

  handleDateChange = (date, id, paramName) => {
    this.setState({ selectedDate: date });
    this.setState({ paramDateName: paramName });
    const resultSurvey = { ...this.state.resultSurvey, [id]: date };
    this.setState({ resultSurvey });
  };

  getRender = data => {
    return data.map((item, key) => {
      switch (item.typeReponse) {
        case "select":
          return this.getSelect(key, item);
        case "ouinon":
          return this.getRadio(key, item);
        case "date":
          return this.getDate(key, item);
        default:
          return this.getRadio(key, item);
      }
    });
  };

  getSelect = (key, item) => {
    return (
      <div className="raw-form" key={key}>
        {
          <span
            className="sub-label align-left"
            dangerouslySetInnerHTML={{ __html: item.label }}
          />
        }
        <div className="wrap-input">
          <Select
            value={this.state.resultSurvey[item.responseId] || ""}
            onChange={e => this.handleChangeSelect(e, item.responseId)}
          >
            {item.listResponse.map((element, keyResponse) => {
              return (
                <MenuItem key={`response-${keyResponse}`} value={element[0]}>
                  {element[1]}
                </MenuItem>
              );
            })}
          </Select>
        </div>
      </div>
    );
  };

  getDate = (key, item) => {
    return (
      <div className="raw-form date" key={key}>
        {
          <span
            className="sub-label align-left"
            dangerouslySetInnerHTML={{ __html: item.label }}
          />
        }
        <KeyboardDatePicker
          autoOk
          variant="inline"
          inputVariant="outlined"
          format="dd/MM/yyyy"
          value={this.state.selectedDate}
          placeholder="jj/mm/aaaa"
          InputAdornmentProps={{ position: "start" }}
          onChange={date =>
            this.handleDateChange(date, item.responseId, item.paramName)
          }
          invalidDateMessage={<Trans id="W_DATE_INVALID" />}
          maxDateMessage={translator()._("W_MAX_DATE_MESSAGE")}
        />
      </div>
    );
  };

  getRadio = (key, item) => {
    return (
      <div className="raw-form" key={key}>
        {
          <span
            className="sub-label align-left"
            dangerouslySetInnerHTML={{ __html: item.label }}
          />
        }
        <RadioGroup
          aria-label="position"
          name={`question-${key}`}
          row
          className="no-wrap"
        >
          <FormControlLabel
            value="Y"
            datavalue="Y"
            control={<Radio color="primary" />}
            label={translator()._("W_OUI")}
            labelPlacement="end"
            onChange={e => this.handleChange(e, item.responseId)}
          />
          <FormControlLabel
            value="N"
            datavalue="N"
            control={<Radio color="primary" />}
            label={translator()._("W_NON")}
            labelPlacement="end"
            onChange={e => this.handleChange(e, item.responseId)}
          />
        </RadioGroup>
      </div>
    );
  };

  handleClick = event => {
    event.preventDefault();
    const keyValueReturned = this.props.step.returned.key;
    //const value = this.state.resultSurvey.join("");
    let value = "";
    if (this.state.paramDateName && this.state.selectedDate) {
      this.props.setDateSurveyFunc({
        name: this.state.paramDateName,
        value: this.state.selectedDate
      });
    }
    Object.keys(this.state.resultSurvey).map(
      key => (value += `|${key};${this.state.resultSurvey[key]}`)
    );
    if (keyValueReturned && value !== "") {
      this.props.isValid(true);
      this.props.setReturnedValue({
        idquestion: this.props.questionId,
        response: null,
        repquestion: value.substring(1)
      });
    } else {
      this.props.isValid(false);
    }
  };

  render() {
    const { step } = this.props;
    const data = this.getData();
    return (
      <div>
        {
          <span
            className="label"
            dangerouslySetInnerHTML={{ __html: step.label }}
          />
        }
        {data && (
          <React.Fragment>
            {this.getRender(data)}
            <div style={{ marginTop: "10px", float: "right" }}>
              <Button
                onClick={this.handleClick}
                className="btn-filled"
                color="primary"
                variant="contained"
                disabled={
                  Object.keys(this.state.resultSurvey).length !== data.length
                }
              >
                <Trans id="W_STEP_BOUTON_CONTINUER" />
              </Button>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

Questionnaire.propTypes = {
  dataSource: PropTypes.any,
  fetchData: PropTypes.func,
  isValid: PropTypes.func,
  questionId: PropTypes.any,
  resetData: PropTypes.func,
  setDateSurveyFunc: PropTypes.func,
  setReturnedValue: PropTypes.func,
  showBtnNext: PropTypes.func,
  step: PropTypes.shape({
    data: PropTypes.shape({
      fetchSource: PropTypes.func,
      formatSource: PropTypes.func,
      keyValue: PropTypes.any
    }),
    label: PropTypes.any,
    returned: PropTypes.shape({
      key: PropTypes.any
    })
  })
};

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource,
    questionId: state.returnedValue.idquestion
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchData: functionName => dispatch(functionName()),
    setReturnedValue: value => dispatch(setReturnedValue(value)),
    resetData: key => dispatch(addFieldData(key, null)),
    showBtnNext: isShow => dispatch(showBtnNext(isShow)),
    setDateSurveyFunc: data => dispatch(setDateSurvey(data))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Questionnaire);
